const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const map = require('mn-utils/map');
const {
  getRFC3339,
} = require('mn-utils/formatTime');
const RefreshIcon = require('@material-ui/icons/Refresh').default;
const withState = require('../../../../utils/withState');
const formatTime = require('../../../../utils/formatTime');
const formatNumCoin = require('../../../../utils/formatNumCoin');
const {
  apiAdminActiveAuctionsList,
} = require('../../../../api/admin/activeAuctions');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const Tooltip = require('../../../dumb/Tooltip/A');
const RowA = require('../../../dumb/Row/A');
const ColA = require('../../../dumb/Col/A');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');
const ButtonD = require('../../../dumb/Button/D');

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayDateTimeAdmin,
  DisplayAmountAdmin
} = require("../../../dumb/DisplayData");
const formatCCSymbol = require("../../../../utils/formatCCSymbol");

const REFRESH_TIMEOUT = 10000;


module.exports = withState((setState, self, onMount) => {
  let _cancel = noop;
  function update(loading) {
    setState({
      loading: loading || 0,
      loadingAuto: 1,
    });
    _cancel();
    _cancel = apiAdminActiveAuctionsList({
      skipError: 1,
    }).finally((error, response) => {
      error || (_cancel = delay(update, REFRESH_TIMEOUT));
      setState({
        loading: false,
        loadingAuto: 0,
        error,
        items: response && response.list || [],
      });
    }).cancel;
  }
  function updateForce() {
    update(1);
  }

  onMount(() => {
    updateForce();
    return () => {
      _cancel();
    };
  });

  return (state, props) => {
    const items = state.items || [];
    const error = state.error;
    const {
      loading,
    } = state;


    return (
      <div {...props}>
        <div className="rlv">
          <div className="abs sh sb layoutRow fvaC fhaE">
            <WrapperWithLoading
              loading={loading}
            >
              <ButtonD
                className="wmin100"
                onClick={updateForce}
              >
                <RefreshIcon/>
                <div className="pl15">Refresh</div>
              </ButtonD>
            </WrapperWithLoading>
          </div>
        </div>
        <WrapperWithLoading
          loading={loading}
        >
          {
            error ? (
              <div className="hmin100 layoutRow fhaS fvaC p15 cF00 bg0 r5">
                <div>
                  <div className="f10">Error</div>
                  <div>{error.message}</div>
                </div>
              </div>
            ) : (
              items.length > 0 ? (<div className="ovxA ov mh-45 ph45">
                <div className="wmin1300">
                  <div>
                    <RowB>
                      <ColB className="w(|min)175 fx1">ID</ColB>
                      <ColB className="w(|min)175 fx1">Order ID</ColB>
                      <ColB className="w(|min)110">Time</ColB>
                      <ColB className="w(|min)150 fx1">SC<br/>Amount</ColB>
                      <ColB className="w(|min)200 fx1">CC<br/>Amount</ColB>
                      <ColB className="w(|min)150 fx1">Wallet/Exchange</ColB>
                      <ColB className="w(|min)150 fx1">Status</ColB>
                      <ColB className="w(|min)120 fx1">Confirmation<br/>timeout</ColB>
                      <ColB className="w(|min)130 fx1">Blockchain<br/>timeout</ColB>
                    </RowB>
                  </div>
                  <div className="mh-45">
                    {map(items, (item) => {
                      const time = item.time || '';
                      const id = item.id;
                      const scAmount = item.sc_amount || 0;
                      const ccAmount = item.cc_amount || 0;

                      return (
                        <RowA key={id}>
                          <ColA className="w(|min)175 fx1">
                            <DisplayIdAdmin>{id}</DisplayIdAdmin>
                          </ColA>
                          <ColA className="w(|min)175 fx1">
                            <DisplayIdAdmin>{item.order_id || 'none'}</DisplayIdAdmin>
                          </ColA>
                          <ColA className="w(|min)110">
                            <DisplayDateTimeAdmin date={time} />
                          </ColA>
                          <ColA className="w(|min)150 fx1">
                            <DisplayAmountAdmin
                              amount={scAmount}
                              symbol={item.sc_code}
                              type="fiat"
                            />
                          </ColA>
                          <ColA className="w(|min)200 fx1">
                            <DisplayAmountAdmin
                              amount={ccAmount}
                              symbol={formatCCSymbol(item.cc_code)}
                              type="coin"
                            />
                          </ColA>
                          <ColA className="w(|min)150 fx1">
                            <DisplayDataAdmin>{item.wallet_kind}</DisplayDataAdmin>
                          </ColA>
                          <ColA className="w(|min)150 fx1">
                            <div>{item.status}</div>
                          </ColA>
                          <ColA className="w(|min)120 fx1">
                            <DisplayDataAdmin>{item.confirmation_timeout}</DisplayDataAdmin>
                          </ColA>
                          <ColA className="w(|min)130 fx1">
                            <DisplayDataAdmin>{item.blockchain_timeout}</DisplayDataAdmin>
                          </ColA>
                        </RowA>
                      );
                    }, [])}
                  </div>
                </div>
              </div>) : (<div
                className="hmin100 layoutRow fhaC fvaC p15 bs bcF1 b1 r5"
              >Empty</div>)
            )
          }
        </WrapperWithLoading>
      </div>
    );
  };
}, {});
